module.exports = __webpack_public_path__ + "img/accounts.b1232a0c.svg";